import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Service } from './service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var DashboardService = /** @class */ (function (_super) {
    tslib_1.__extends(DashboardService, _super);
    function DashboardService(http) {
        var _this = _super.call(this) || this;
        _this.http = http;
        _this.endpoint = _this.getEndpoint('dashboard');
        return _this;
    }
    DashboardService.prototype.getRecordsWithIssues = function () {
        return this.http.get(this.endpoint + '/data-quality-issues')
            .pipe(catchError(this.handleError('getRecordsWithIssues', [])));
    };
    DashboardService.prototype.getRecordTypeDistribution = function () {
        return this.http.get(this.endpoint + '/record-distribution')
            .pipe(catchError(this.handleError('getRecordTypeDistribution', { distribution: [], totalRecords: 0 })));
    };
    DashboardService.prototype.getPaidUpMembersOverTime = function () {
        return this.http.get(this.endpoint + '/paid-members-timeline')
            .pipe(catchError(this.handleError('getPaidUpMembersOverTime', [])));
    };
    DashboardService.prototype.getFinanceSummary = function () {
        return this.http.get(this.endpoint + '/finance-summary')
            .pipe(catchError(this.handleError('getFinanceSummary', { months: [], outstandingFees: 0 })));
    };
    DashboardService.prototype.getEmailCoverage = function () {
        return this.http.get(this.endpoint + '/email-coverage')
            .pipe(catchError(this.handleError('getEmailCoverage', { withEmail: 0, total: 0, percentage: 0 })));
    };
    DashboardService.prototype.getFundraisingProjects = function () {
        return this.http.get(this.endpoint + '/fundraising-projects')
            .pipe(catchError(this.handleError('getFundraisingProjects', [])));
    };
    DashboardService.prototype.getRecentActivity = function () {
        return this.http.get(this.endpoint + '/recent-activity')
            .pipe(map(function (items) { return items.map(function (i) { return (tslib_1.__assign({}, i, { timestamp: new Date(i.timestamp) })); }); }), catchError(this.handleError('getRecentActivity', [])));
    };
    DashboardService.ngInjectableDef = i0.defineInjectable({ factory: function DashboardService_Factory() { return new DashboardService(i0.inject(i1.HttpClient)); }, token: DashboardService, providedIn: "root" });
    return DashboardService;
}(Service));
export { DashboardService };
